// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_AT_RULE_IMPORT_0___ from "-!../../../../node_modules/css-loader/dist/cjs.js!./global.css";
import ___CSS_LOADER_AT_RULE_IMPORT_1___ from "-!../../../../node_modules/css-loader/dist/cjs.js!./synchrony-presence.css";
import ___CSS_LOADER_AT_RULE_IMPORT_2___ from "-!../../../../node_modules/css-loader/dist/cjs.js!./page-editor.css";
import ___CSS_LOADER_AT_RULE_IMPORT_3___ from "-!../../../../node_modules/css-loader/dist/cjs.js!./page-editor-icons.css";
import ___CSS_LOADER_AT_RULE_IMPORT_4___ from "-!../../../../node_modules/css-loader/dist/cjs.js!./tinymce-editor.css";
import ___CSS_LOADER_AT_RULE_IMPORT_5___ from "-!../../../../node_modules/css-loader/dist/cjs.js!./editor-toolbar.css";
import ___CSS_LOADER_AT_RULE_IMPORT_6___ from "-!../../../../node_modules/css-loader/dist/cjs.js!./editor-toolbar-split-buttons.css";
import ___CSS_LOADER_AT_RULE_IMPORT_7___ from "-!../../../../node_modules/css-loader/dist/cjs.js!./toolbar-icons.css";
import ___CSS_LOADER_AT_RULE_IMPORT_8___ from "-!../../../../node_modules/css-loader/dist/cjs.js!./editor-comments.css";
import ___CSS_LOADER_AT_RULE_IMPORT_9___ from "-!../../../../node_modules/css-loader/dist/cjs.js!./view-page.css";
import ___CSS_LOADER_AT_RULE_IMPORT_10___ from "-!../../../../node_modules/css-loader/dist/cjs.js!./fonts.module.css";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_0___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_1___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_2___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_3___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_4___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_5___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_6___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_7___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_8___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_9___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_10___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
`, "",{"version":3,"sources":[],"names":[],"mappings":"","sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
